import React, {useEffect, useState} from 'react';
import styles from "./testReport.module.scss";
import {Candle, IOrder, ISeriesOfTransaction, ITestReport} from "../../../shared/types";
import {
  getAnnualAmountOrders,
  getAverageAnnualIncome,
  getAverageDrawdownPerOrder,
  getAverageDurationTransaction,
  getAverageIncomeInOrder,
  getMaxDrawdownPerOrder,
  getMaxDurationTransaction,
  getMaxIncomeInOrder,
  getMinDurationTransaction,
  getMinIncomeInOrder,
  getRatioMaxDrawdownPerOrder,
  getRatioMaxDurationTransaction,
  getRatioRandomIncomeInOrder,
  getSchwagerCoefficient,
  getStrategyQualityFactor,
  getIncomeInTest,
  getInvolvementCoefficient, getPossibleIncome, calculateSurrogateCloseTransaction
} from "../../../shared/lib/lib";

interface Props {
  history: Array<Candle> | undefined
  series: Array<ISeriesOfTransaction> | undefined
}

const TestReport = ({history, series}: Props) => {

  const [orders, setOrders] = useState<Array<IOrder>>()

  //для упрощения расчета результатов теста массив серии сделок трансформируем в массив сублимированных сделок
  useEffect(() => {
    const orders: Array<IOrder> = []
    if (series && series?.length !== 0) {
      series.forEach((oneSeries) => {
        const oneOrder = calculateSurrogateCloseTransaction(oneSeries)
        orders?.push({
          enter: {price: oneOrder.enter.price, date: oneOrder.enter.date, value: oneOrder.enter.value},
          exit: {price: oneOrder.exit.price, date: oneOrder.exit.date, value: oneOrder.exit.value}
        })
      })
      setOrders(orders)
    }
  }, [series])

  //отчетные данные по результатам тестирования
  const [testReport, setTestReport] = useState<ITestReport | undefined>()

  //расчет показателей стратегии по массиву тестовых сделок
  useEffect(() => {
    if (orders && orders?.length !== 0 && history && history?.length !== 0) {
      let amountOrders = orders.length
      let annualAmountOrders = getAnnualAmountOrders(history, orders)
      let averageDurationTransaction = getAverageDurationTransaction(orders)
      let minDurationTransaction = getMinDurationTransaction(orders)
      let maxDurationTransaction = getMaxDurationTransaction(orders)
      let incomeInTest = getIncomeInTest(orders)
      let averageIncomeInOrder = getAverageIncomeInOrder(incomeInTest, orders)
      let minIncomeInOrder = getMinIncomeInOrder(orders)
      let maxIncomeInOrder = getMaxIncomeInOrder(orders)
      let averageAnnualIncome = getAverageAnnualIncome(annualAmountOrders, averageIncomeInOrder)
      let averageDrawdownPerOrder = getAverageDrawdownPerOrder(history, orders)
      let maxDrawdownPerOrder = getMaxDrawdownPerOrder(history, orders)
      let ratioMaxDurationTransaction = getRatioMaxDurationTransaction(averageDurationTransaction, maxDurationTransaction)
      let ratioMaxDrawdownPerOrder = getRatioMaxDrawdownPerOrder(averageIncomeInOrder, maxDrawdownPerOrder)
      let ratioRandomIncomeInOrder = getRatioRandomIncomeInOrder(averageIncomeInOrder, maxIncomeInOrder)
      let strategyQualityFactor = getStrategyQualityFactor(ratioMaxDurationTransaction, ratioMaxDrawdownPerOrder, ratioRandomIncomeInOrder)
      let schwagerCoefficient = getSchwagerCoefficient(averageAnnualIncome, maxDrawdownPerOrder)
      let involvementCoefficient = getInvolvementCoefficient(history, orders)
      let possibleIncome = getPossibleIncome(averageAnnualIncome, involvementCoefficient)

      setTestReport({
        averageAnnualIncome,
        amountOrders,
        annualAmountOrders,
        averageDrawdownPerOrder,
        averageDurationTransaction,
        averageIncomeInOrder,
        incomeInTest,
        maxDrawdownPerOrder,
        maxDurationTransaction,
        maxIncomeInOrder,
        minDurationTransaction,
        minIncomeInOrder,
        ratioMaxDrawdownPerOrder,
        ratioMaxDurationTransaction,
        ratioRandomIncomeInOrder,
        schwagerCoefficient,
        strategyQualityFactor,
        involvementCoefficient,
        possibleIncome,
      })
    } else {
      setTestReport(undefined)
    }
  }, [orders, history])

  if (!testReport) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.title}>Результаты тестирования</p>
        <p className={styles.divider}></p>
        <p className={[styles.line, styles.green].join(' ')}>доходность среднегодовая (доходность)
          - <span>{testReport?.averageAnnualIncome}%</span></p>
        <p className={[styles.line, styles.green].join(' ')}>доходность при 100% вовлеченности (возможная доходность)
          - <span>{testReport?.possibleIncome}%</span></p>
        <p className={styles.line}>коэффициент качества стратегии (стабильность)
          - <span>{testReport?.strategyQualityFactor}</span></p>
        <p className={styles.line}>коэффициент Швагера (безопасность) - <span>{testReport?.schwagerCoefficient}</span>
        </p>
        <p className={styles.line}>коэффициент не вовлеченности (доп. возможности)
          - <span>{testReport?.involvementCoefficient}</span></p>
        <p className={styles.divider}></p>
        <p className={styles.line}>коэффициент максимальной продолжительности сделки
          - <span>{testReport?.ratioMaxDurationTransaction}</span></p>
        <p className={styles.line}>коэффициент максимальной просадки в сделке
          - <span>{testReport?.ratioMaxDrawdownPerOrder}</span></p>
        <p className={styles.line}>коэффициент случайной доходности в сделке
          - <span>{testReport?.ratioRandomIncomeInOrder}</span></p>
        <p className={styles.divider}></p>
        <p className={styles.line}>кол-во сделок в тесте - <span>{testReport?.amountOrders}шт</span></p>
        <p className={styles.line}>кол-во сделок среднегодовое - <span>{testReport?.annualAmountOrders}шт</span></p>
        <p className={styles.line}>продолжительность сделки средняя
          - <span>{testReport?.averageDurationTransaction} дней</span></p>
        <p className={styles.line}>продолжительность сделки, минимальная
          - <span>{testReport?.minDurationTransaction} дней</span></p>
        <p className={styles.line}>продолжительность сделки, максимальная
          - <span>{testReport?.maxDurationTransaction} дней</span></p>
        <p className={styles.divider}></p>
        <p className={styles.line}>доходность в тесте - <span>{testReport?.incomeInTest}%</span></p>
        <p className={styles.line}>доходность среднегодовая - <span>{testReport?.averageAnnualIncome}%</span></p>
        <p className={styles.line}>доходность средняя на сделку - <span>{testReport?.averageIncomeInOrder}%</span></p>
        <p className={styles.line}>доходность минимальная на сделку - <span>{testReport?.minIncomeInOrder}%</span></p>
        <p className={styles.line}>доходность максимальная на сделку - <span>{testReport?.maxIncomeInOrder}%</span></p>
        <p className={styles.divider}></p>
        <p className={styles.line}>просадка средняя на сделку - <span>{testReport?.averageDrawdownPerOrder}%</span></p>
        <p className={styles.line}>просадка максимальная на сделку - <span>{testReport?.maxDrawdownPerOrder}%</span></p>
      </div>
    </div>
  );
};

export default TestReport;